//
// GENERATED by Kilua RPC
//
package dev.kilua.rpc

import web.http.Request
import kotlinx.serialization.modules.SerializersModule

inline fun <reified T : Any> getService(serializersModules: List<SerializersModule>? = null, noinline requestFilter: (suspend Request.() -> Unit)? = null): T = when (T::class) {
    rpc.AppService::class -> rpc.AppServiceImpl(serializersModules, requestFilter) as T
    else -> throw IllegalArgumentException("Unknown service ${T::class}")
}

actual inline fun <reified T : Any> getService(serializersModules: List<SerializersModule>?): T = getService(serializersModules, null)

